import { createContext, useContext, useState } from "react";

const GamificationContext = createContext()

export default function GamificationProvider({ children }) {

    const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
    const [type, setType] = useState("")

    return (
        <GamificationContext.Provider value={{
            openConfirmationModal,
            setOpenConfirmationModal,
            type,
            setType,
        }}>
            {children}
        </GamificationContext.Provider>
    )
}

export function useGamification() {
    return useContext(GamificationContext)
}

